export default __webpack_public_path__ + "media/transfer_window/terms_and_conditions-bcee97e8.gif";